<template>
  <div class="home">
    <Download/>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
    >
      <div v-for="i in list" :key="i.id">
        <Aggregate v-if="i.is_group == '1'" :liveinfo="i"/>
        <Thumb v-else :liveinfo="i"/>
      </div>
    </van-list>
  </div>
</template>

<script>
import Thumb from '../components/Thumb'
import Aggregate from '../components/Aggregate'
import Download from '../components/Download'
export default {
  components: {
    Thumb,
    Aggregate,
    Download
  },
  data() {
    return {
      active: 0,
      orgid: orgid,
      cateList: [],
      list: [],
      loading: false,
      finished: false,
      page: 1,
      cateId: '0',
      livecateid: livecateid
    }
  },
  methods: {

    /**
     * 获取列表信息
     */
    fetchLiveList(page=1, id) {
      this.$jsonp(`${this.baseConfig.apiRoot}/v1/app/live?_orgid_=${this.orgid}`, {
        callbackQuery: 'cqcallback',
        page: page,
        livecateid: this.livecateid
      }).then(res => {
        this.list = this.list.concat(res.data.infos);
        this.loading = false;
        if(res.data.infos.length < 10) {
          this.finished = true;
        }
      })
    },

    /**
     * 点击tab触发
     */
    handleTabsClick(id, title) {
      this.cateId = id;
      this.list = [];
      this.finished = false;
      this.page = 1;
      this.loading = true;
      this.fetchLiveList(this.page, id)
    },

    /**
     * 列表触底触发
     */
    onLoad() {
      this.page++;
      this.fetchLiveList(this.page, this.cateId)
    }
  },
  mounted() {
    // this.fetchCateList()
    this.fetchLiveList(1, '0')
  }
}
</script>
<style scoped>
.home {
  box-sizing: border-box;
  padding-top: 1.25rem;
}
</style>
<style>
.van-tabs__nav--card {
  margin: 0;
  border: none;
}
.van-tab {
  font-size: .32rem;
}
.van-tabs--card>.van-tabs__wrap {
  /* box-sizing: border-box; */
  height: 1rem;
  /* padding: .3rem 0; */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.van-tabs__nav--card{
  height: .6rem;
}
.van-tabs__nav--card .van-tab {
  height: .6rem;
  border-right: none;
  background-color: #f3f3f3;
  margin-right: .2rem;
  border-radius: .1rem;
  padding: 0 .3rem;
}
.van-tabs__content {
  margin-top: 1rem;
}
</style>